import { IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import ModalContext from '~/context/srp/ModalContext';
import { ListenerEvent, ListenerEventType } from './constants';

type SaveSearchMessage = IncomingMessage<ListenerEventType, {}>;

function isSaveSearchMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is SaveSearchMessage {
  return message.event === ListenerEvent.SaveSearch;
}

export default function useSaveSearchHandler(): MessageHandler<ListenerEventType> {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { setCreateSavedSearchOpen } = useContext(ModalContext);

  return useMemo(
    () =>
      new MessageHandler(isSaveSearchMessage, () => {
        setCreateSavedSearchOpen(true, appliedFilters);
      }),
    [appliedFilters, setCreateSavedSearchOpen]
  );
}
